import template from "./template";

export default function filterHelper(baseArray = [], ...args) {
  return baseArray.filter(item => {
    const value = template(item, ...args);
    return !(value === false || value === "false");
  });
}
